<template>
  <!-- Komponent odpowiedzialny za wybór typu wykresu (np. liniowy, słupkowy) -->
  <div class="graph-type ds-panel">
    <!-- Nagłówek sekcji (typ wykresu) -->
    <div class="ds-panel__head">
      <h3 class="margin-0">{{ t('chart-type').toUpperCase() }}</h3>
    </div>

    <div class="ds-panel__body">
    <!-- Select do wyboru typu wykresu, powiązany z filtrem w store -->
    <select class="form-select" name="graphType" v-model.lazy="value">
      <!-- Lista opcji do wyboru generowana dynamicznie na podstawie store.graphType -->
      <option
        v-for="(option, index) in store.graphType"
        :key="index"
        :value="index"
      >
        <!-- Tłumaczenie nazwy opcji, np. "Liniowy", "Słupkowy" -->
        {{ t(option) }}
      </option>
    </select>
  </div>
  </div>

</template>

<script>
import { watch, ref } from "vue";

export default {
  // Oczekiwany obiekt store z filtrami (przekazany przez rodzica)
  props: {
    store: { required: true },
  },
  name: "GrapfTypeFilter", // (uwaga, literówka: powinno być GraphTypeFilter)
  setup(props) {
    // Reaktywna wartość powiązana z wybranym typem wykresu
    const value = ref(props.store.filters.graphType);

    // Funkcja zapisująca zmianę wartości do store
    const saveValue = (text) => {
      props.store.addItem("graphType", text);
    };

    // Reaguj na zmianę value i aktualizuj store
    watch(value, (newValue) => {
      saveValue(newValue); // wywołanie przy każdej zmianie selecta
    });

    return { value };
  },
};
</script>
<style scoped>
/* Panel filtra — obramowanie, nagłówek i odstępy pochodzą z design-system.css. */
.graph-type {
  min-width: 0;
}

.graph-type .form-select,
.graph-type select {
  width: 100%;
  min-width: 0;
  height: var(--control-height);
  font-size: var(--font-size-sm);
}
</style>
